import { gridConfig } from '@core/config/grid.config';

export function getViewportWidth() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.visualViewport?.width ?? window.innerWidth ?? document.documentElement.clientWidth;
}

export default function () {
  if (typeof window === 'undefined') {
    return false;
  }

  return getViewportWidth() <= gridConfig.breakpoints.lg;
}
